import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Post } from "../lib/sanity/types";
import { getAllBlogPosts } from "../lib/sanity/data";
import { RootState } from "./store";

type PostsState = {
  items: Post[];
  isLoading: boolean;
  error: string | null;
};

const initialState: PostsState = {
  items: [],
  isLoading: false,
  error: null,
};

export const fetchPosts = createAsyncThunk<Post[]>(
  "posts/fetchAll",
  async () => (await getAllBlogPosts()) ?? []
);

const postsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    clearPosts(state) {
      state.items = [];
      state.isLoading = false;
      state.error = null;
    },
    clearPostsError(state) {
      state.error = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchPosts.pending, (s) => {
      s.isLoading = true;
      s.error = null;
    });
    b.addCase(fetchPosts.fulfilled, (s, a) => {
      s.isLoading = false;
      s.items = a.payload ?? [];
    });
    b.addCase(fetchPosts.rejected, (s, a) => {
      s.isLoading = false;
      s.error = a.error.message || "Failed to load posts";
    });
  },
});

export const { clearPosts, clearPostsError } = postsSlice.actions;
export default postsSlice.reducer;

export const selectPosts = (s: RootState) => s.posts.items;
export const selectPostsLoading = (s: RootState) => s.posts.isLoading;
export const selectPostsError = (s: RootState) => s.posts.error;

export const selectTopPosts =
  (n = 3) =>
  (s: RootState) =>
    [...s.posts.items]
      .sort((a, b) => ((a.publishedAt ?? "") < (b.publishedAt ?? "") ? 1 : -1))
      .slice(0, n);
